import variable from './variable';
import * as commonFuns from './modules/styles/styles-functions';

(function ($) {

    $(document).ready(()=>{

        var csBanner_index = 0;
        $('#main-content section').each(function () {
            csBanner_index ++;
            if ($(this).hasClass('csBanner')) {
                return false;
            }
        });
        $('section.csBanner .carousel-banner-top li').addClass('arc');

        // Use Custom Event from source/js/auto-scroll.js
        $('#main-content').on('scroll_direction', function (e, direction, destination) {
            if (destination == csBanner_index) {
                setTimeout(()=>{
                    $('section.csBanner .carousel-banner-top li').addClass('arc');
                }, 300);
            } else {
                $('section.csBanner .carousel-banner-top li').removeClass('arc');
            }
        });

        $(document).on('fullpage_loaded', () => {

            $('.owl-carousel').each((i, elm) => {
                $(elm).trigger('refresh.owl.carousel');
            });

        })

        initSliders();

    function initSliders()
    {
        $('.owl-carousel').each(function (index, el) {

            var nav, dots = false;
            var lazyLoad = true;
            var loop = true;
            var customDots = false;
            var items = 1;
            var that = $(this);

            var responsive = {};
            var navText = ["<i class='fa bg-chevron'></i>","<i class='fa bg-chevron'></i>"];
            var then;

            var initFunction = function () { }

            if ($(this).hasClass('banners-top')) {
                dots = true;
                // then = '.banners-top';
            } else if ($(this).hasClass('carousel-hotpot') || $(this).hasClass('carousel-why-wait') || $(this).hasClass('carousel-specifications') ) {
                nav = dots = true;

                if ($(this).hasClass('carousel-hotpot')) {
                    then = '.carousel-hotpot';
                } else if ($(this).hasClass('carousel-why-wait')) {
                    then = '.carousel-why-wait';
                } else if ($(this).hasClass('carousel-specifications')) {
                    then = '.carousel-specifications';
                }

                if ($(this).hasClass('carousel-hotpot') || $(this).hasClass('carousel-why-wait')) {
                    initFunction = function (elem) {
                        random(elem);
                    }
                }
            } else if ($(this).hasClass('carousel-seawind')  || $(this).hasClass('carousel-recommend-option') || $(this).hasClass('carousel-banner-top')) {
                nav = true;
                if ($(this).hasClass('carousel-seawind')) {
                    then = '.carousel-seawind';
                } else if ($(this).hasClass('carousel-recommend-option')) {
                    then = '.carousel-recommend-option';
                    items = 3;
                    responsive = {
                        0 : {items:1},
                        576: {items: 2},
                        769: {items: 3}
                    }
                }

                if ($(this).hasClass('carousel-seawind') || $(this).hasClass('carousel-enquire') || $(this).hasClass('carousel-recommend-option') ) {
                    initFunction = function (elem) {
                        random(elem);
                    }
                }
            } else if ($(this).hasClass('carousel-dtwice-reverse') || $(this).hasClass('carousel-dtwice-reverse-2')|| $(this).hasClass('carousel-enquire')) {
                nav = dots = false;
                loop = false;
                if ($(this).hasClass('carousel-dtwice-reverse')) {
                    then = '.carousel-dtwice-reverse';
                } else if ($(this).hasClass('carousel-dtwice-reverse-2')) {
                    then = '.carousel-dtwice-reverse-2';
                } else if ($(this).hasClass('carousel-enquire')) {
                    then = '.carousel-enquire';
                }
                if ($(this).hasClass('carousel-dtwice-reverse') || $(this).hasClass('carousel-dtwice-reverse-2') ) {
                    initFunction = function (elem) {
                        random(elem);
                    }
                }
            }

            if ($(then).hasClass('carousel-recommend-option')) {
                var owl = {
                    items: 3,
                    smartSpeed: 1100,
                    nav: nav,
                    navText: '',
                    loop: loop,
                    dots: dots,
                    lazyLoad: true,
                    lazyLoadEager: 1,
                    dotsContainer: customDots,
                    onInitialize: initFunction,
                    responsive: responsive,
                    onLoadedLazy: () => {
                        $(document).trigger('onOwlLoadedLazy')
                    }
                };

                var owl_carousel = $(then).owlCarousel(owl);
                $('#owl-nav-custom .owl-prev').click(function () {
                    owl_carousel.trigger('prev.owl.carousel');
                });

                $('#owl-nav-custom .owl-next').click(function () {
                    owl_carousel.trigger('next.owl.carousel');
                });
            } else {
                let mouseDrag = true;
                let touchDrag = true;

                if ($(then).children().length === 1) {
                    loop = false;
                    mouseDrag = false;
                    touchDrag = false;
                }

                var owl = {
                    items: items,
                    smartSpeed: 1100,
                    nav: nav,
                    navText: navText,
                    loop: loop,
                    dots: dots,
                    mouseDrag: mouseDrag,
                    touchDrag: touchDrag,
                    lazyLoad: true,
                    lazyLoadEager: 3,
                    dotsContainer: customDots,
                    onInitialize: initFunction,
                    responsive: responsive,
                    onLoadedLazy: () => {
                        $(document).trigger('onOwlLoadedLazy')
                    }
                };

                $(then).owlCarousel(owl);
            }
        });
    }

        percent_imgdot('#footer .content_block-quat-icon .content_block');

        resize_carousel();

        $('.carousel-specifications .owl-dot').addClass('o8');
        $('.cshotpot .owl-dot').addClass('o8');
        $('.cs-why-wait .owl-dot').addClass('o8');

        computePositionButtonBanner();

        $('.is-video-autoplay').each(function (index, el) {
            $(this).addClass('is-video-No-'+index);
        });
        $('.csEnquire .video').each(function (index, el) {
            $(this).attr('data-video-no','enquire-video-No-'+index);
        });

        $('.carousel-enquire .owl-item').each(function (index, el) {
            if ($(this).hasClass('active')) {
                $(this).addClass('zindex_-50');
                $(this).removeClass('zindex_-100');
            } else {
                $(this).removeClass('zindex_-50');
                $(this).addClass('zindex_-100');
            }
        });
        var cs_enquire = $(".carousel-enquire");
        cs_enquire.on('dragged.owl.carousel', function (e) {
            e.preventDefault();

            var conditrion = $(this).find('.owl-item').attr('class');
            $(e.target).find('.owl-item').each(function (index, el) {
                if ($(this).hasClass('active')) {
                    $(this).addClass('zindex_-50');
                    $(this).removeClass('zindex_-100');
                } else {
                    $(this).removeClass('zindex_-50');
                    $(this).addClass('zindex_-100');
                }

            });
        });

        var csBanner_LiImg = $('.csBanner .carousel-banner-top.normal-bannertop li img');
        csBanner_LiImg.each(function (index, el) {
            $(this).attr('src', $(this).attr('data-src'));
        });

        csBanner_LiImg.hover(function () {
            /* Stuff to do when the mouse enters the element */
            if (!$(this).parents('li').hasClass('active')) {
                $(this).attr('src', $(this).attr('data-alt-src'));
                $(this).css({
                    'max-height': '148px',
                    'height': '148px'
                });
            }

        }, function () {
            /* Stuff to do when the mouse leaves the element */
            if (!$(this).parents('li').hasClass('active')) {
                $(this).attr('src', $(this).attr('data-src'));
                $(this).css('max-height', '');
                $(this).css('height', '');
            }

        });


        $('.carousel-banner-top .owl-dot__').on('click', function (event) {
            event.preventDefault();
            /* Act on the event */
            $('.carousel-banner-top .owl-dot__').each(function (index, el) {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).find('img').attr('src', $(this).find('img').attr('data-src'));
                }
            });
            $(this).addClass('active');
            $(this).find('img').attr('src', $(this).find('img').attr('data-alt-src'));

            var link_el = $(this).find('a');
            setTimeout(function () {
                var target = $(link_el).attr('target')? $(link_el).attr('target') : '_self';
                var url = $(link_el).attr('href');
                var winbr = window.open(url, target);
                winbr.focus();
            }, 500);
        });

        $('.csBanner .button-drop').click(function (event) {
            event.preventDefault();
            $.fn.fullpage.moveSectionDown();
            $('.csBanner .button-drop').fadeOut('slow');
        });

        $('.videomyI').each(function (index, el) {
            var video = $(this).attr('data-src');
            if (video != '') {
                $(this).append('<source src="' + video + '" type="video/mp4" >');
                $(this).attr('data-src','');
            }
            // $(this)[0].play();
        });

        var turn = 0;
        $(".is-video-autoplay .iframe-wrapper").on('click',function (e) {

            var thix = $(this).find('.TRP');
            var video = '.is-video-autoplay .video';

            var before = $(this).closest('.is-video-autoplay').attr('class');
            var after = before.slice(before.indexOf('is-video-No-'));
            var mid = after.slice(0,after.indexOf(' '));
            var _index = mid.slice(mid.lastIndexOf('-')+1);

            if (thix.hasClass('ift')) {
                thix.removeClass('ift');
                $(video)[_index].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
            } else {
                thix.addClass('ift');
                $(video)[_index].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
            }

            if (turn == 0 ) {
                $(video)[_index].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
                turn = 1;
            } else {
                $(video)[_index].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                turn = 0;
            }

            e.preventDefault();

            if (thix.hasClass('ift')) {
                thix.removeClass('ift')
            } else {
                thix.addClass('ift');
            }
        });


        $(".carousel-news-grid .image-aero-box-").click(function () {
            window.location = $(this).find("a").attr("href");
            return false;
        });
        $(".carousel-news-grid .image-aero-box-0").click(function () {
            window.location = $(this).find("a").attr("href");
            return false;
        });
        $(".carousel-news-grid .image-aero-box-1").click(function () {
            window.location = $(this).find("a").attr("href");
            return false;
        });
        $('html').on("speed_network", function (e, speed) {
            initTheBanner(speed);
        });
    });

    $(window).on('resize', function () {
        resize_carousel();
        computePositionButtonBanner();
    });

    $(document).on('fullpage-loaded', function (e, section) {
        if ($(window).width() >= 992) {
            fullpageJS(section, once_360);
        } else {
            fullpageJS($('section.section'), once_360);
        }
    });

    $(window).on('load',  function (event) {
        event.preventDefault();
        var active = $('section.active');
        fullpageJS(active, once_360);
    });

    //Sort random function
    function random(owlSelector)
    {

        var container = $(owlSelector.target);

        container.children().sort(function () {
            return Math.round(Math.random()) - 0.5;
        }).each(function () {
            $(this).appendTo(container);
        });
    }

    function percent_imgdot(target)
    {
        var array_ft = [];
        var maxValue = 0;
        $(target).each(function (index, el) {
            $(this).addClass('dotx_'+index);
            array_ft.push($(this).find($('.ft')).data('ft'));
            maxValue = Math.max.apply(Math, array_ft);
        });
        $(target).each(function (index, el) {
            var ft = $(this).find($('.ft')).data('ft');
            var percent =   ft  / maxValue *  100;
            var result = 120 * (100 - percent) / 100;

            if ($(this).hasClass('dotx_3')) {
                result = result *1.26;
                $(this).find($('img')).css('padding-top', result+'px');
            } else {
                $(this).find($('img')).css('padding-top', result+'px');
            }
        });
    }

    /* */
    function var_window_(target, height_, after)
    {
            
        function var_window_height(if_, else_)
        {
            setTimeout(function () {
                if (if_ == true) {
                    let height = $(height_).outerHeight(true);
                    $(target).css('height', 'calc(100vh - '+ height +'px)');
                    $(after).height('100%');
                }
                if (else_ == true) {
                    $(target).css('height', 'auto');
                    $(after).height($(target).height());
                }
            },500);
        }
        if (window.matchMedia('(min-width: 992px)').matches) {
            var_window_height(true);
        } else {
            var_window_height('', true);
        }
    }
    /* */
    function ATM_scroll(target, bool = false ,button = '', event = '')
    {
        $(target).each(function (index, el) {

            function ATM(then, bool)
            {
                var B = $(then).find($('.scrollbar'))[0].scrollHeight;
                var A = $(then).height();
                if (A < B ) {
                    // console.log('True');
                    $(then).hover(function () {
                        $.fn.fullpage.setAllowScrolling(false);
                    }, function () {
                        $.fn.fullpage.setAllowScrolling(true);
                    });
                } else if (bool == true && A >=  B) {
                    // console.log('False');
                    $(then).hover(function () {
                        $.fn.fullpage.setAllowScrolling(true);
                    }, function () {
                        $.fn.fullpage.setAllowScrolling(true);
                    });
                }
            }

            ATM(this, bool)
            if (button != '' && event != '') {
                $(button).on(event, function (e) {
                    e.preventDefault();
                    ATM(target, bool);
                });
            }

        });
    }
    /* */
    function ATM_width(calc_A, calc_B, obj, method)
    {

        var calculator_B = 0;
        $(calc_B).each(function (index, el) {
            calculator_B += $(this).outerWidth(true);
        });
        var calc_A;
        if (method == 'width') {
            calc_A = $(calc_A).width();
        } else if (method == 'outerWidth') {
            calc_A = $(calc_A).outerWidth(true);
        }

        $(obj).css('width', 'calc('+calc_A+'px - '+calculator_B+'px )');

    }
    /* */
    function resize_carousel()
    {

        commonFuns.justifybutton('.banners-top');
        commonFuns.justifybutton('#footer .footer-logo .button');
        commonFuns.justifybutton('.social-wrap');
        commonFuns.justifybutton('.cshotpot');
        // justifybutton('.cs-why-wait', 'on');

        var_window_('.cs-why-wait .carousel-why-wait', '.cs-why-wait .block-hotpot-footer', '.cs-why-wait .bg_img');
        var_window_('.cshotpot .carousel-hotpot', '.cshotpot .block-hotpot-footer', '.cshotpot .bg_img');

        ATM_scroll('.clone-double-twice .ATM', true);

        if (window.matchMedia('(min-width: 992px)').matches) {
        } else {
            $('.cs-why-wait .block-hotpot-footer .ATM').css('width','auto');
            $('.cshotpot .block-hotpot-footer .ATM').css('width','auto');
        }
        var enquire_item = $('.carousel-enquire');
        if (enquire_item.attr('data-bg')!= '') {
            enquire_item.find('.owl-item').css('background-color',enquire_item.attr('data-bg'));
            enquire_item.attr('data-bg','');
        }

        if (window.matchMedia('(max-width: 1300px)').matches) {
            $(".carousel-enquire .videomyI").removeClass('z-index-large');
            $(".carousel-enquire .videomyI").addClass('z-index-small');
        } else {
            $(".carousel-enquire .videomyI").addClass('z-index-large');
            $(".carousel-enquire .videomyI").removeClass('z-index-small');
        }
        if (window.matchMedia('(max-width: 1100px)').matches) {
            var height_map = 'calc( 100vh - '+$('.carousel_map .top').height()+'px - '+$('.carousel_map .bottom').height()+'px )';
            $('.carousel_map #map').css('height',height_map);
        } else {
            var height_map = 'calc(100vh - 100px - '+$('.carousel_map .top').height()+'px)';
            $('.carousel_map #map').css('height',height_map);
        }

        if (window.matchMedia('(max-width: 991px)').matches) {
            $('.carousel-hotpot').addClass('not-annotation');
        } else {
            $('.carousel-hotpot').removeClass('not-annotation');
        }
        $('.social-languagues ul').css('width',$('.navbar #primary-menu').width());

        $('.videomyI').css('width', 'value');

        if ($(window).width() >= variable('bp_fullpage')) {
            $('#owl-carousel-sync-third-grid-1').css('height', 'calc(100vh - '+$('.cs-image-gallery-third-grid .social-wrap').outerHeight()+'px )');
            $('#owl-carousel-sync-third-grid-2').css('height', 'calc(100vh - '+$('.cs-image-gallery-third-grid .social-wrap').outerHeight()+'px )');

            var height_news_gird = $('.carousel-news-grid').css('height');
            $('.carousel-news-grid .grid-wrap').css('height', height_news_gird);
        }

    }/* END resize_carousel */

    function hotpot_spec(target,action,select='')
    {
        $(target).on(action,select, function (e) {
            e.preventDefault();
            var thix;
            var thixNot;
            if (select == '') {
                thix = $(this).find('.owl-item.active .FEATURE__ a');
                thixNot = $(this).find('.owl-item').not('.active');
            } else {
                thix = $(this).closest(target).find('.owl-item.active .FEATURE__ a');
                thixNot = $(this).closest(target).find('.owl-item').not('.active');
            }
            thix.each(function (index, el) {
                $(this).attr('style', $(this).attr('data-style-e'));
            });
            
            thixNot.each(function (index, el) {
                $(this).find('a').attr('style','');
            });
        });
    };

    var once_360 = 0;
    function fullpageJS(section, once_360)
    {
        if ($(section).hasClass('csEnquire')) {
            $('.csEnquire .videomyI').each(function (index, el) {
                var No = parseInt($(this).attr('data-video-no'));
                $(this)[0].play();
            });
        } else if ($(section).hasClass('is-video-autoplay')) {
            var video = '.is-video-autoplay .video';
            $('.is-video-autoplay').each(function (index, el) {
                if ($(section).hasClass('is-video-No-'+index)) {
                    var xrc = $('.is-video-No-'+index).find('.video').attr('data-src');


                    if (xrc != '' ) {
                        $('.is-video-No-'+index).find('.video').attr('src', xrc);
                        xrc = $('.is-video-No-'+index).find('.video').attr('data-src','');
                    }
                }
            });
        } else if ($(section).hasClass('cs-free-style')) {
             $('.cs-free-style .videomyI').each(function (index, el) {

                $(this)[0].play();
             });

             if ($(section).find('#pano').length > 0){
                 $(section).find('.fp-tableCell').css({'verticalAlign': 'top'});
                 $(section).find('#pano').css({'height': 'calc(100vh - 200px)'});
             }
        } else if ($(section).hasClass('csBanner')) {
            $('.csBanner .videomyI').each(function (index, el) {

                $(this)[0].play();
            });
            setTimeout(function () {
                $('.csBanner .button-drop').fadeIn('slow');
            },300);
        } else if ( $(section).hasClass('cshotpot')) {
            // $('section.cshotpot').addClass('active_v2');
            $('.carousel-hotpot .owl-item.active .FEATURE__ a').each(function (index, el) {
                $(this).attr('style', $(this).attr('data-style-e'));
            });
            
            hotpot_spec('.carousel-hotpot','dragged.owl.carousel');
            hotpot_spec('.carousel-hotpot','click','.owl-next, .owl-prev');
            hotpot_spec('.carousel-hotpot','click','.owl-dot');
        } else {
            $('.carousel-hotpot .FEATURE__ a').attr('style', '');
        }
        

        if ( $(section).hasClass('cs-matterport') ) {
            var xrc = $('.cs-matterport .content').attr('data-src');
            if (xrc != '') {
                $('.cs-matterport .content').attr('src', xrc);
                $('.cs-matterport .content').attr('data-src', '');
            }
            if ($('.cs-matterport .maskTRP .d').hasClass('d-none')) {
                $('#header .TRP_right').removeClass('d-none');
            } else {
                $('#header .TRP_right').addClass('d-none');
            }
            $('.cs-matterport .maskTRP label').removeClass('d-none')
            $('.cs-matterport .maskTRP').on('click', function (event) {
                // shadow_box_('#fp-nav.left','shadow_box_01','remove');
                if ($('#header .TRP_right').hasClass('active')) {
                    $('#header .TRP_right').removeClass('active');
                }
                $(this).css('display', 'none');
                $(this).find('div').addClass('d-none');
                $('#header .TRP_right').removeClass('d-none');
                once_360 = 1;
            });

            $('#header .TRP_right').on('click', function (e) {
                e.preventDefault();
                $('.cs-matterport .maskTRP').css('display', 'block');
                $(this).addClass('active');
            });
            if (once_360 == 1) {
                $('#header .TRP_right').removeClass('d-none');
            }
        } else {
            $('#header .TRP_right').addClass('d-none');
        }
    }

    jQuery(document.documentElement).keyup(function (event) {

        var owl = jQuery(".fullscreen-section.active .owl-carousel");

        // handle cursor keys
        if (event.keyCode == 37) {
            owl.find('.owl-prev').trigger('click');
        } else if (event.keyCode == 39) {
            owl.find('.owl-next').trigger('click');
        }

    });

    function initTheBanner(speed)
    {

        var bannerElement = $('.banners-top');

        if ($('.carousel-banner-top').length > 0) {
            if (banner_background.length > 0) {
                if ( (speed == '3g' && banner_background.length > 1) || ($(window).width() < 992)) {
                    let new_banner_background = [];
                    banner_background.forEach(function (item, index) {
                        if (item.image_or_video.type != 'video') {
                            new_banner_background.push(item);
                        }
                    });
                    banner_background = new_banner_background;
                }
                var random = getRndInteger(0, banner_background.length, 'banner-top');
                var randomize = banner_background[random];

                if (randomize.image_or_video.type == 'video') {
                    bannerElement.prepend('<video class="videomyI fullscreen-section bg_img dot_img lazy-load-bg-image z-index-large" autoplay muted loop src="'+ randomize.image_or_video.url +'"></div>');
                } else if (randomize.image_or_video.type == 'image') {
                    let the_using_url = randomize.image_or_video.url;

                    if ($(window).width() < 992) {
                        the_using_url = randomize.image_or_video.sizes.medium_large;
                    }

                    bannerElement.prepend('<div class="fullscreen-section bg_img dot_img lazy-load-bg-image" style="background-image: url(' + the_using_url  + ')"></div>');
                }
            }
        }
    }

    function computePositionButtonBanner()
    {
        // var height_carousel_sailor = $('#carousel-custom-dots .image-origin').height();
        // $('.banners-top .content_block').css('bottom', height_carousel_sailor + 80);
        $('.banners-top .content_block').css('bottom', 132 + 80 + 15);
        // $('.banners-top .content_block').css('bottom', 132 + 80);
    }

    /**
     * Function name: getRndInteger
     *
     * Description: return random one number but this have condition is previous value random had been save in cookie for one by one slider
     *
     * @param {integer} min
     * @param {integer} max
     * @param {string} saveCookie
     * @returns integer*
     */
    var cookies = getCookies(); //get cookie of website
    function getRndInteger(min, max, saveCookie)
    {
        var random_value = Math.floor(Math.random() * (max - min)) + min;
        return random_value;
    }

    /**
     * Function name: getCookies
     *
     * Description: get Cookie of website and convert to object by key-value
     *
     * @returns Object
     */

    function getCookies()
    {
        var cookiesObject = {};
        var cookies = document.cookie.split("; ");
        if (cookies && cookies.length === 0) {
            for (var i = 0; i < cookies.length; i++) {
                var key = cookies[i].split('=')[0];
                var value = cookies[i].split('=')[1];
                cookiesObject[key] = value;
            }
        }
        return cookiesObject;
    }

})(jQuery);